// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"styles_NotFound__ciJMu","NotFoundBody":"styles_NotFoundBody__rcXXn","BackHome":"styles_BackHome__2k0rR"};